import { useEffect } from "react";
import type { ReactNode } from "react";
import PopupHandler from "components/utils/PopupHandler/PopupHandler";
import ScrollToTop from "components/utils/ScrollToTop";
import TitlesUtil from "components/utils/TitlesUtil";
import { DataProvider } from "providers/DataProvider";
import SnackbarProvider from "providers/SnackbarProvider";
import { Outlet, useLocation } from "react-router";
import Footer from "./Footer";
import Header from "./Header/Header";
import { useOnlineStatus } from "providers/OnlineStatusProvider";

function Root(): ReactNode {
  const location = useLocation();
  const { checkIfOnline } = useOnlineStatus();
  // On vérifie si l'utilisateur est en ligne ou non à chaque navigation
  useEffect(() => {
    void checkIfOnline();
  }, [location, checkIfOnline]);

  return (
    <SnackbarProvider>
      <DataProvider>
        <Header isAuthenticated />
        <Outlet />
        <Footer />
        <ScrollToTop />
        <TitlesUtil />
        <PopupHandler />
      </DataProvider>
    </SnackbarProvider>
  );
}

export default Root;
